import { ExtendedVariant } from 'shared/types/product/Variant';

const FALLBACK_LEAD_TIME_DAYS = 14;
export const getVariantLeadTime = (variant: ExtendedVariant) => variant.leadTime ?? FALLBACK_LEAD_TIME_DAYS;
